module.exports = __webpack_public_path__ + "static/media/bg_c.edfea563.svg";